<template>
  <div class="detail">
    <!-- 顶部 -->
    <detailHeader />
    <div class="orderDetail">
      <div class="search">
        <div class="item">
          <el-input v-model="order_sn" placeholder="请输入订单号" clearable></el-input>
        </div>
        <el-button type="primary" @click="orderDetails">查询</el-button>

      </div>
      <div class="table">
        <ol>
          <li class="flex05">
            <el-checkbox v-model="checkedAll" @change="handleCheckAllChange"></el-checkbox>
          </li>
          <li class="flex05">番号</li>
          <li>图片</li>
          <li>商品名称</li>
          <li>商品属性</li>
          <li>下单数据</li>
          <li>实时数据</li>
          <li>当前状态</li>
          <li>纳期</li>
        </ol>
        <ul v-for="item in detail.order_detail" :key="item.id">
          <li class="flex05">
            <el-checkbox v-model="item.checked" @change="handleSelectChange"></el-checkbox>
          </li>
          <li class="flex05">{{ item.sorting }}</li>
          <li>
            <el-image :src="item.pic" fit="fill" :preview-src-list="[item.pic]"
              style="width: 80px; height: 80px; margin-right: 10px;" />
            <div class="icon">
              <p style="margin-bottom: 20px;">
                <a :href="item.link" target="_blank" rel="noopener noreferrer">
                  <img src="https://img.alicdn.com/imgextra/i1/O1CN01FLiUvb1K4szSnB9fw_!!6000000001111-2-tps-176-68.png"
                    style="width: 30px;"></img>
                </a>
              </p>
              <a :href="`https://www.rakumart.com/ProductDetails?goods_id=${item.goods_id}&fromPlatform=${item.from_platform}`"
                target="_blank" rel="noopener noreferrer">
                <img src="@/assets/img/logo2.png" style="width: 30px;"></img>
              </a>
            </div>
          </li>
          <li>
            <el-input v-model="item.title" placeholder="请输入商品名称" clearable type="textarea"
              @blur="saveTitle(item)"></el-input>
          </li>
          <li>
            <div class="template">
              <div class="row">
                <label>颜色：</label> <el-input v-model="item.color" placeholder="请输入颜色" clearable
                  @blur="saveColor(item)"></el-input>
              </div>
              <div class="row">
                <label>尺寸：</label> <el-input v-model="item.size" placeholder="请输入尺寸" clearable
                  @blur="saveSize(item)"></el-input>
              </div>
            </div>
          </li>
          <li>
            <div class="template">
              <p>数量：{{ item.confirm_num }}</p>
              <p>单价：{{ item.confirm_price }}</p>
            </div>
          </li>
          <li>
            <div class="template">
              <p>数量：{{ item.offer_num_bak }}</p>
              <p>单价：{{ item.offer_price_bak }}</p>
            </div>
          </li>
          <li>
            {{ item.statusName }}
          </li>
          <li>
            <div class="template">
              <el-input v-model="item.delivery_days" placeholder="请输入纳期" clearable style="width: 200px;" type="number"
                @input="allEdit(item, 'delivery_days')">
                <template slot="append">
                  天
                </template>
              </el-input>
            </div>
          </li>
        </ul>
      </div>
      <div class="foot">
        <el-button type="primary" @click="saveDeliveryDays">
          保存
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import { mapState } from 'vuex'
export default {
  components: {
    detailHeader,
  },
  computed: {
    ...mapState({
      detail: (state) => state.orderDetail.detail,
    }),
  },
  data() {
    return {
      token: localStorage.getItem('japan_access_token'),
      tableData: [],
      order_sn: '',
      checkedAll: false,
    };
  },
  created() {

  },
  methods: {
    //获取详情
    orderDetails() {
      let datas = {
        order_sn: this.order_sn,
        is_japanfirm: this.$route.query.is_japanfirm,
      }
      this.checkedAll = false
      this.$api.orderApi
        .orderDetails(datas)
        .then((res) => {
          this.$api.orderApi
            .getDeliveryDays(datas)
            .then((result) => {
              res.data.order_detail.forEach(item => {
                item.checked = false
                result.data.list.forEach(deliver => {
                  if (item.id == deliver.order_detail_id) {
                    item.delivery_days = deliver.delivery_days
                    item.title = deliver.title
                    item.color = deliver.color
                    item.size = deliver.size
                  }
                })
              })
              this.$store.commit('getDetail', res.data)
            })
          // 存入vuex

        });
    },
    // 全选
    handleCheckAllChange() {

      this.detail.order_detail.forEach((item) => {
        item.checked = this.checkedAll;
      });
      this.$forceUpdate();
    },
    // 是否全选
    handleSelectChange() {
      this.checkedAll = this.detail.order_detail.every((item) => item.checked);
    },
    // 保存订单纳期
    saveDeliveryDays() {
      let datas = {
        order_sn: this.order_sn,
        items: []
      }
      this.detail.order_detail.forEach(item => {
        datas.items.push({
          order_detail_id: item.id,
          delivery_days: item.delivery_days,
        })
      })
      this.$api.orderApi
        .saveDeliveryDays(datas)
        .then((res) => {
          this.$message.success(res.msg)

        });
    },
    // 保存商品名称
    saveTitle(item) {
      this.$api.orderApi
        .saveTitle({
          order_detail_id: item.id,
          value: item.title,
          order_sn: this.order_sn,
        })
        .then((res) => {
          this.$message.success(res.msg)
        });
    },
    // 保存颜色
    saveColor(item) {
      this.$api.orderApi
        .saveColor({
          order_detail_id: item.id,
          value: item.color,
          order_sn: this.order_sn,
        })
        .then((res) => {
          this.$message.success(res.msg)
        });
    },
    // 保存尺寸
    saveSize(item) {
      this.$api.orderApi
        .saveSize({
          order_detail_id: item.id,
          value: item.size,
          order_sn: this.order_sn,
        })
        .then((res) => {
          this.$message.success(res.msg)
        });
    },
    // 批量修改
    allEdit(data, type) {
      if (data.checked) {
        this.detail.order_detail.forEach((item) => {
          if (item.checked) {
            item[type] = data[type];
          }
        });
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.detail {
  min-width: 1910px;
}

/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

.search {
  display: flex;
  margin-bottom: 20px;
  position: relative;

  .item {
    width: 300px;
  }
}

.orderDetail {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;
  margin: 24px;

  .tabs {
    margin-bottom: 20px;
  }

  .table {
    font-size: 14px;

    ol {
      position: sticky;
      top: 0;
      left: 0;
      z-index: 9;
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      justify-content: center;
      align-items: center;

      li {
        height: 40px;
        text-align: center;
        align-items: center !important;
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 30px;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }

    .flex05 {
      flex: 0.3;
      position: relative;
    }

    .flex2 {
      flex: 2;
    }

    .flex15 {
      flex: 1.5;
    }

    ul {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #edeff4;
      transition: all 0.3s;
      min-height: 100px;
    }
  }

  .foot {
    text-align: right;
    margin-top: 24px;
    position: sticky;
    right: 0;
    bottom: 0;
    background-color: #f8f8f8;
    padding: 12px;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.1);
    z-index: 99;
  }

  .row {
    display: flex;
    margin-bottom: 10px;

    label {
      width: 80px;
      line-height: 40px;
    }
  }
}
</style>
